// Utilidad para manejar links dinámicamente basándose en el dominio actual

/**
 * Detecta si estamos en el subdominio de cartilla (producción o QA)
 */
export const isCartillaSubdomain = () => {
  const hostname = window.location.hostname
  return hostname.includes('cartilla.')
}

/**
 * Detecta si estamos en el subdominio app.wiri.la (dominio principal para wiri)
 */
export const isAppWiriSubdomain = () => {
  const hostname = window.location.hostname
  return hostname.includes('app.wiri.la')
}

/**
 * Detecta si estamos en el entorno de QA
 */
export const isQAEnvironment = () => {
  const hostname = window.location.hostname
  return hostname.includes('.qa.')
}

/**
 * Obtiene el dominio base actual para generar links
 */
export const getCurrentDomain = () => {
  const hostname = window.location.hostname
  
  // Si estamos en el subdominio de cartilla, usar ese dominio
  if (hostname.includes('cartilla.')) {
    return `https://${hostname}`
  }
  
  // Si estamos en wiri.la, usar wiri.la
  if (hostname.includes('wiri.la')) {
    return 'https://wiri.la'
  }
  
  // Si estamos en wiri.com.ar, usar wiri.com.ar
  if (hostname.includes('wiri.com.ar')) {
    return 'https://wiri.com.ar'
  }
  
  // Por defecto, usar el dominio actual
  return window.location.origin
}

/**
 * Obtiene el dominio de cartilla correcto según el entorno
 */
export const getCartillaDomain = () => {
  if (isQAEnvironment()) {
    return 'https://cartilla.qa.drapp.com.ar'
  }
  return 'https://cartilla.drapp.com.ar'
}

/**
 * Genera un link absoluto basándose en el dominio actual
 */
export const getAbsoluteLink = (path) => {
  const domain = getCurrentDomain()
  return `${domain}${path.startsWith('/') ? path : `/${path}`}`
}

/**
 * Genera un link de cartilla (equipos, profesionales, turnos)
 * Siempre apunta al dominio de cartilla correcto según el entorno
 */
export const getCartillaLink = (path) => {
  const domain = getCartillaDomain()
  return `${domain}${path.startsWith('/') ? path : `/${path}`}`
}

/**
 * Genera un link de equipo basándose en el dominio actual
 */
export const getTeamLink = (teamId, date) => {
  return getCartillaLink(`/equipos/${teamId}/${date}`)
}

/**
 * Genera un link de profesional basándose en el dominio actual
 */
export const getProfessionalLink = (slug, id) => {
  return getCartillaLink(`/profesional/${slug}/${id}`)
}

/**
 * Genera un link de checkout basándose en el dominio actual
 */
export const getCheckoutLink = (code) => {
  return getCartillaLink(`/turnos/checkout/${code}`)
}

/**
 * Obtiene el nombre de la marca según el dominio actual
 */
export const getBrandName = () => {
  if (isCartillaSubdomain()) {
    return 'Cartilla DrApp'
  }
  return 'Wiri Salud'
}

/**
 * Obtiene el nombre corto de la marca según el dominio actual
 */
export const getShortBrandName = () => {
  if (isCartillaSubdomain()) {
    return 'DrApp'
  }
  return 'Wiri'
}

/**
 * Obtiene el título de la página según el dominio actual
 */
export const getPageTitle = () => {
  if (isCartillaSubdomain()) {
    return 'Cartilla DrApp | Cartilla de Profesionales | ¡Sin pagos mensuales!'
  }
  return 'Wiri Salud | Medicina Privada Accesible | ¡Sin pagos mensuales!'
}

/**
 * Obtiene la descripción de la página según el dominio actual
 */
export const getPageDescription = () => {
  if (isCartillaSubdomain()) {
    return 'Accede a servicios de salud de calidad, transparentes, accesibles y convenientes: consultas médicas, estudios, descuentos en farmacias y mucho más en Cartilla DrApp.'
  }
  return 'Accede a servicios de salud de calidad, transparentes, accesibles y convenientes: consultas médicas, estudios, descuentos en farmacias y mucho más en Wiri Salud.'
}

/**
 * Obtiene el mensaje de WhatsApp según el dominio actual
 */
export const getWhatsAppMessage = () => {
  if (isCartillaSubdomain()) {
    return 'Hola, acabo de solicitar un turno por medio de Cartilla DrApp. Te paso los detalles asi me lo confirmas'
  }
  return 'Hola, acabo de solicitar un turno por medio de Wiri. Te paso los detalles asi me lo confirmas'
}

/**
 * Obtiene el mensaje de WhatsApp HTML según el dominio actual
 */
export const getWhatsAppMessageHTML = () => {
  if (isCartillaSubdomain()) {
    return 'Hola, acabo de solicitar un turno por medio de Cartilla DrApp. Te paso los detalles para confirmarlo'
  }
  return 'Hola, acabo de solicitar un turno por medio de Wiri. Te paso los detalles para confirmarlo'
}

/**
 * Obtiene el copyright según el dominio actual
 */
export const getCopyright = () => {
  if (isCartillaSubdomain()) {
    return 'Cartilla DrApp - Todos los derechos reservados © 2025'
  }
  return 'Wiri Salud - Todos los derechos reservados © 2025'
}
